import { render, staticRenderFns } from "./Backend.vue?vue&type=template&id=adbe700a&"
import script from "./Backend.vue?vue&type=script&lang=js&"
export * from "./Backend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports